import React, { useCallback, useEffect, useState } from 'react';
import { BiChevronDown } from 'react-icons/bi';
import { AiOutlineSearch } from 'react-icons/ai';
import { MdAddBox } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { useUser, usePost } from '../../hooks';
import { LangArrayToObjKeyValue } from '../../utils/global';
import { useCurrent } from '../../hooks';
import MwInputText from './MwInputText';

const MwSelectorProduct = ({
  onChangeCallback,
  onCreateProduct,
  reloadProductList,
  withLabel = false,
  invalid = false,
  initalValue,
  disabled = false,
  showSearchInList = true,
  inputStyle = {},
  placeholder,
}) => {
  const [t] = useTranslation('global');
  const { currentLangId } = useCurrent();
  const { getUser } = useUser();
  const [products, setProducts] = useState([]);
  const [productsFilter, setProductsFilter] = useState([]);
  const [inputValue, setInputValue] = useState(initalValue || '');
  const [selectedItem, setSelectedItem] = useState(null);
  const [open, setOpen] = useState(false);
  const { data: resultPost, postData } = usePost();

  // دالة التحقق من تحديث المنتجات
  const isProductsUpdated = () => {
    try {
      return JSON.parse(localStorage.getItem('isProductsUpdated') || 'false');
    } catch {
      return false;
    }
  };

  // تحميل المنتجات من API
  const fetchProducts = useCallback(async () => {
    try {
      const payload = {
        tenantId: getUser?.tenant_id,
        companyId: getUser?.company_id,
        // productType: 'Sales',
      };
      
      await postData(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/search/All`, payload);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  }, [getUser?.company_id, getUser?.tenant_id, postData]);

  // استدعاء البيانات عند تحميل المكون
  useEffect(() => {
    const loadProducts = async () => {
      const storedProducts = localStorage.getItem('products');
      const shouldUpdate = isProductsUpdated() || !storedProducts || reloadProductList;

      if (shouldUpdate) {
        await fetchProducts();
      } else if (storedProducts) {
        try {
          const parsedProducts = JSON.parse(storedProducts);
          setProducts(parsedProducts);
        } catch (error) {
          console.error('Error parsing stored products:', error);
          await fetchProducts();
        }
      }
    };

    loadProducts();
  }, [fetchProducts, reloadProductList]);

  // تحديث المنتجات عند استجابة API
  useEffect(() => {
    if (resultPost?.data) {
      const productsData = resultPost.data;
      setProducts(productsData);
      localStorage.setItem('products', JSON.stringify(productsData));
      localStorage.setItem('isProductsUpdated', 'false');
    }
  }, [resultPost]);

  // تحديث القائمة المفلترة عند تغيير قيمة البحث
 // تعديل دالة تصفية المنتجات في useEffect الخاص بالبحث
useEffect(() => {
  if (products && products.length > 0) {
    if (!inputValue) {
      setProductsFilter(products);
    } else {
      const filtered = products.filter((product) => {
        // نتحقق من أن المنتج من نوع المبيعات (إذا كان هذا مطلوبًا)
        if (product.productType !== "Sales" && product.productType !== "SalesAndPurchases") {
          return false;
        }
        
        // الحصول على اسم المنتج بناءً على اللغة الحالية
        const productNameAr = product?.productName?.[0]?.text || '';
        const productNameEn = product?.productName?.[1]?.text || '';
        const productBarcode = product?.productBarcode || '';
        const productCode = product?.productCode || '';
        
        // البحث في جميع الحقول
        return productNameAr.toLowerCase().includes(inputValue.toLowerCase()) ||
               productNameEn.toLowerCase().includes(inputValue.toLowerCase()) ||
               productBarcode.toLowerCase().includes(inputValue.toLowerCase()) ||
               productCode.toLowerCase().includes(inputValue.toLowerCase());
      });
      setProductsFilter(filtered);
    }
  }
}, [inputValue, products, currentLangId]);

  useEffect(() => {
    console.log("selectedItem:", selectedItem)
    if (selectedItem) {
      onChangeCallback(selectedItem);
    }
  }, [onChangeCallback, selectedItem]);

  const handleProductSelect = (product) => {
    setSelectedItem(product);
    setOpen(false);
    setInputValue('');
  };

  const defaultInputStyle = {
    textAlign: 'center',
    ...inputStyle
  };

  return (
    <div className="relative">
      {withLabel && (
        <label className="mb-1 block px-1 text-xs font-medium text-[#251658]">{t('invoice.selectProduct')}</label>
      )}
      
      <div
        onClick={() => !disabled && setOpen(!open)}
        className={`flex  w-full items-center justify-between rounded-xl border bg-white text-sm ${
          invalid ? 'border-red-400' : 'border-slate-200 hover:border-slate-300'
        } ${disabled ? 'text-slate-200' : 'text-slate-500'}`}
      >
        {selectedItem ? (
          <span className={`w-full text-start px-3 ${disabled ? 'text-slate-300' : 'text-slate-700'}`}>
            {LangArrayToObjKeyValue(selectedItem.productName)?.[currentLangId] ||
              selectedItem.productName[0]?.text ||
              selectedItem.productName[1]?.text}
          </span>
        ) : (
            <MwInputText
              disabled={disabled}
              value={inputValue}
              style={defaultInputStyle}
              classNameInput="border-0 bg-transparent px-3 text-start font-medium text-slate-700 focus:ring-0 hover:border-transparent"
              onChange={(e) => {
                setInputValue(e.target.value);
                setOpen(true);
            }}
            onFocus={() => setOpen(true)}
            placeholder={placeholder || t('product.searchProduct')}
            />
          )}
        <BiChevronDown size={20} className="m-2 rounded border border-slate-200 text-slate-500" />
      </div>

      {open && (
        <ul className="absolute z-50 max-h-60 w-screen overflow-y-auto rounded-2xl border border-slate-200 bg-white pe-12 shadow-xl md:w-full md:pe-0">
          <div className="sticky top-0 border-b border-slate-100 bg-white p-3">
            <div className="text-end">
              {onCreateProduct && (
                <div className="absolute top-6 end-5 text-[#251658]" onClick={() => onCreateProduct(true)}>
                  <MdAddBox size={24} />
                </div>
              )}
            </div>
            {showSearchInList && (
            <div className="flex items-center justify-between rounded-xl border border-slate-200 bg-slate-50 px-3">
              <AiOutlineSearch size={18} className="text-slate-500" />
              <input
                type="text"
                placeholder={t('product.searchProduct')}
                className="w-full bg-transparent p-2 text-sm text-slate-700 outline-none placeholder:text-slate-400"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </div>
            )}
          </div>

          <div className="max-h-[300px] overflow-y-auto">
            {productsFilter.map((product) => (
              <li
                key={product._id}
                onClick={() => handleProductSelect(product)}
                className="cursor-pointer border-b border-slate-100 py-2 ps-5 text-sm transition-colors hover:bg-[#251658]/5"
              >
                <div className="flex gap-5 justify-between">
                  <div>
                    <div className="text-slate-800">
                      {LangArrayToObjKeyValue(product.productName)?.[currentLangId] ||
                        product.productName[0]?.text ||
                        product.productName[1]?.text}
                    </div>
                    <div className="text-xs text-slate-400">
                      {product.productName?.[1]?.text || product.productName?.[0]?.text}
                    </div>
                    <div className="text-xs text-slate-400">
                      {product.productDesc?.[currentLangId === 'ar' ? 0 : 1]?.text || ''}
                    </div>
                    <div className="text-xs text-slate-400">
                      {product?.productBarcode && (
                        <span className="me-2">
                          {t('common.barcode')}: {product.productBarcode}
                        </span>
                      )}
                      {product?.productCode && (
                        <span>
                          {t('common.code')}: {product.productCode}
                        </span>
                      )}
                    </div>
                  </div>
                  {/* <div className="text-xs font-bold text-slate-500 p-3">
                    {product?.productBrand?.brandName?.length > 0 && (
                      <span className="bg-sky-200 rounded-lg px-1 py-1 mx-1">
                        {LangArrayToObjKeyValue(product.productBrand.brandName)?.[currentLangId] ||
                          product.productBrand.brandName[0]?.text ||
                          product.productBrand.brandName[1]?.text}
                      </span>
                    )}
                    {product?.productCategory?.[0]?.categoryName?.length > 0 && (
                      <span className="bg-sky-200 rounded-lg px-1 py-1 mx-1">
                        {LangArrayToObjKeyValue(product.productCategory[0].categoryName)?.[currentLangId] ||
                          product.productCategory[0].categoryName[0]?.text ||
                          product.productCategory[0].categoryName[1]?.text}
                      </span>
                    )}
                  </div> */}
                      <div className='p-3 text-xs font-bold text-slate-500'>
                                                 <div className='flex flex-wrap gap-1 mb-1'>
                                                    {product?.productBrand?.brandName?.length > 0 && <span className='inline-block rounded-full bg-[#251658]/10 px-2 py-1 text-[#251658]'>
                                                        {LangArrayToObjKeyValue(product?.productBrand?.brandName)?.[currentLangId] || product?.productBrand?.brandName[0]?.text || product?.productBrand?.brandName[1]?.text}
                                                    </span>}
                                                    {product?.productCategory[0]?.categoryName?.length > 0 && <span className='inline-block rounded-full bg-slate-100 px-2 py-1 text-slate-600'>
                                                        {LangArrayToObjKeyValue(product?.productCategory[0]?.categoryName)?.[currentLangId] || product?.productCategory[0]?.categoryName[0]?.text || product?.productCategory[0]?.categoryName[1]?.text}
                                                    </span>}
                                                 </div>
                                                 <span className='mt-1 inline-block rounded-full bg-[#eef6e4] px-2 py-1 text-[10px] text-[#699635]'>
                                                     {t('common.qty')}: {product?.qty || 0}
                                                 </span>
                                             </div>
                </div>
              </li>
            ))}
          </div>
        </ul>
      )}
    </div>
  );
};

export default MwSelectorProduct;
